import { useEffect, useState } from 'react'
import type { User } from '../../types'
import { canSeeCabinetBirthdays } from '../../lib/cabinetBirthdaysAccess'
import { loadTodayBirthdays, type CabinetBirthdayPerson } from '../../lib/apiPhpAdapter'
import { formatDisplayNameFromString } from '../../utils/employeeDisplay'
import './CabinetTodayBirthdays.css'

type Props = {
  user: User
}

function ageLabel(age: number): string {
  const mod100 = age % 100
  const mod10 = age % 10
  if (mod100 >= 11 && mod100 <= 14) return `${age} let`
  if (mod10 === 1) return `${age} rok`
  if (mod10 >= 2 && mod10 <= 4) return `${age} roky`
  return `${age} let`
}

/** Plný seznam — bez ořezání, přelomí se na více řádků. */
export function CabinetTodayBirthdays({ user }: Props) {
  const allowed = canSeeCabinetBirthdays(user)
  const [items, setItems] = useState<CabinetBirthdayPerson[] | null>(null)

  useEffect(() => {
    if (!allowed) return
    let cancelled = false
    loadTodayBirthdays()
      .then((res) => {
        if (!cancelled) setItems(res.birthdays || [])
      })
      .catch(() => {
        if (!cancelled) setItems([])
      })
    return () => {
      cancelled = true
    }
  }, [allowed])

  if (!allowed || !items || items.length === 0) return null

  return (
    <div className="cab-birthdays" aria-label="Dnešní narozeniny">
      <span className="cab-birthdays__label">Dnes mají narozeniny</span>
      <ul className="cab-birthdays__list">
        {items.map((p) => (
          <li key={p.id} className={p.is_jubilee ? 'is-jubilee' : undefined}>
            <strong>{formatDisplayNameFromString(p.name)}</strong>
            <span className="cab-birthdays__age">
              {' '}
              ({ageLabel(p.age)}
              {p.is_jubilee ? ', jubileum' : ''})
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
